// ** React Imports
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';

// ** Redux Imports
import { Provider } from 'react-redux';
import { store } from './redux/storeConfig/store';

// ** Toast & ThemeColors Context
import { ToastContainer } from 'react-toastify';
import { ThemeContext } from './utility/context/ThemeColors';

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner';

// ** Ability
import ability from './configs/acl/ability';
import { AbilityContext } from './utility/context/Can';

// ** Ripple Button
import './@core/components/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss';
import 'react-toastify/dist/ReactToastify.css';

// ** Core styles
import './@core/assets/fonts/fonts.css';
import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style.scss';

// ** Service Worker
import * as serviceWorker from './serviceWorker';

// ** Axios
import axios from 'axios';

// ** Recaptcha
import RecaptchaProvider from './components/Recaptcha';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:3001/';

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

ReactDOM.render(
	<Provider store={store}>
		<Suspense fallback={<Spinner />}>
			<AbilityContext.Provider value={ability}>
				<ThemeContext>
					<RecaptchaProvider>
						<LazyApp />
						<ToastContainer newestOnTop limit={1}/>
					</RecaptchaProvider>
				</ThemeContext>
			</AbilityContext.Provider>
		</Suspense>
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
